module.exports = __webpack_public_path__ + "static/locales/vi.14BDtwx.json";